// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"b7635b5199--wrapper--_waya","wrapper-scroll":"b7635b5199--wrapper-scroll--Vf2TA"};